import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DataElement, PaginationModel } from "src/app/shared/models/common";
import { Clinic } from "src/app/shared/models/clinic.model";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { TabIdList } from "src/app/shared/models/tab.model";
import { UiUser } from "src/app/shared/models/ui-user.model";
import { Store } from "@ngrx/store";
import {
  EDIT_USER,
  GET_CLINIC_USERS,
  UI__SET_ACTIVE_TABS,
} from "src/app/shared/ngrx/ngrx-actions";
import { roleList } from "src/app/shared/ngrx/ngrx-selectors";
import { take } from "rxjs/operators";
import { CommonModule } from "@angular/common";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "clinic-list",
  templateUrl: "./clinic-list.component.html",
  styleUrls: ["./clinic-list.component.sass"],
  standalone: true,
  imports: [CommonModule, TableComponent, TooltipDirective, TranslateModule],
})
export class ClinicListComponent implements OnInit {
  @Input() clinics: Clinic[];
  @Output() onEditClinic = new EventEmitter<Clinic>();
  @Input() totalRecords: number;
  @Input() numberOfRows: number;
  @Output() requestUpdate = new EventEmitter<PaginationModel>();

  tabIdList: TabIdList = new TabIdList();
  routeEnum: RouteEnum = new RouteEnum();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {}

  getUsers(clinic: Clinic) {
    this.store.dispatch(
      GET_CLINIC_USERS({
        clinic: clinic,
      })
    );

    this.store.dispatch(
      UI__SET_ACTIVE_TABS({
        data: [{ link: this.routeEnum.URL_MNG_USERS }],
      })
    );
  }

  createUser(clinic: Clinic) {
    let newUser = new UiUser();
    newUser.clinic = clinic;

    this.store
      .select(roleList)
      .pipe(take(1))
      .subscribe((roleList) => {
        newUser.role = roleList.find((r) => r.id == "DOCTOR");

        this.store.dispatch(
          EDIT_USER({
            user: newUser,
          })
        );
      });
  }

  editClinic(clinic: Clinic) {
    this.onEditClinic.emit(clinic);
  }

  outputPaginationData($event: PaginationModel) {
    this.requestUpdate.emit($event);
  }
}
